<top-banner variant="title" title="Work Flow Approvals"></top-banner>

<div class="main-content">
  <div class="row animated fadeIn">
    <div class="col-md-12">
      <div class="card inbox-page">
        <div class="card-body mb-2">
          <div class="inbox-title">
            <i class="fas fa-inbox inbox-title-icon"></i>
            <h4 class="card-title mb-0">Inbox</h4>
            <span class="badge badge-danger inbox-title-badge">{{ totalApprovalsCount }}</span>
          </div>

          <ul class="nav nav-tabs inbox-tabs">
            <li *ngFor="let tab of workflowTabs" class="nav-item">
              <a
                class="nav-link"
                [class.disabled]="!tab.enabled"
                [class.active]="activeWorkflowTabKey === tab.key"
                (click)="setActiveWorkflowTab(tab.key)">
                <span>{{ tab.label }}</span>
                <span class="badge badge-pill ml-2" [ngClass]="tab.count > 0 ? 'badge-danger' : 'badge-secondary'">
                  {{ tab.count }}
                </span>
              </a>
            </li>
          </ul>

          <div *ngIf="!isActiveTabAvailable()" class="alert alert-warning mb-3">
            This workflow category is not available yet in the new API.
          </div>

          <ng-container *ngIf="isActiveTabAvailable()">
            <div class="filter-flex-row inbox-filters filter-fields-uniform">
              <div *ngIf="isSiteFilterAvailable()">
                <!-- the label and hint change per tab because a site reaches the items two
                     different ways - see siteFilterHint -->
                <label [ngbTooltip]="siteFilterHint">
                  {{ siteFilterLabel }}
                  <i class="fas fa-info-circle text-muted ml-1"></i>
                </label>
                <div class="filter-field">
                  <p-dropdown
                    class="form-control"
                    [options]="sitesArray"
                    [(ngModel)]="selectedSite"
                    (ngModelChange)="onSelectedSiteChange($event)"
                    (onFocus)="ensureSitesLoaded()"
                    (click)="ensureSitesLoaded()"
                    optionLabel="label"
                    filter="true">
                  </p-dropdown>
                  <button
                    class="btn btn-clear"
                    [ngbTooltip]="'clear filter'"
                    placement="bottom"
                    (click)="clearSite()">
                    <i class="fa fa-times"></i>
                  </button>
                </div>
              </div>
              <div>
                <label>Search</label>
                <text-filter-box
                  placeholder="Name, email, site, asset, reason..."
                  [initialText]="keyword"
                  (onFilterTextChanged)="onKeywordChanged($event)">
                </text-filter-box>
              </div>
              <div>
                <label>Updated from</label>
                <div class="filter-field">
                  <p-calendar
                    class="form-control"
                    [(ngModel)]="fromDate"
                    (ngModelChange)="onFromDateChange($event)"
                    dateFormat="dd/mm/yy"
                    [showButtonBar]="true"
                    [minDate]="earliestFilterDate"
                    [maxDate]="toDate || today">
                  </p-calendar>
                  <button
                    class="btn btn-clear"
                    [ngbTooltip]="'clear filter'"
                    placement="bottom"
                    (click)="clearFromDate()">
                    <i class="fa fa-times"></i>
                  </button>
                </div>
              </div>
              <div>
                <label>Updated to</label>
                <div class="filter-field">
                  <p-calendar
                    class="form-control"
                    [(ngModel)]="toDate"
                    (ngModelChange)="onToDateChange($event)"
                    dateFormat="dd/mm/yy"
                    [showButtonBar]="true"
                    [minDate]="fromDate || earliestFilterDate"
                    [maxDate]="today">
                  </p-calendar>
                  <button
                    class="btn btn-clear"
                    [ngbTooltip]="'clear filter'"
                    placement="bottom"
                    (click)="clearToDate()">
                    <i class="fa fa-times"></i>
                  </button>
                </div>
              </div>
              <div *ngIf="pendingLoading || completeLoading" class="small-spinner">
                <p-progressSpinner [strokeWidth]="5"></p-progressSpinner>
              </div>
              <!-- the window is a hard floor in both APIs, not just a calendar limit, so it has to
                   be visible: without it an empty Completed tab reads as a bug -->
              <p class="w-100 mb-0 text-muted small">
                <i class="fas fa-info-circle mr-1"></i>
                {{ filterWindowNote }}
              </p>
            </div>

            <div class="d-flex justify-content-end align-items-center mb-3">
              <filter-summary-display [items]="activeFiltersSummary"></filter-summary-display>
            </div>

            <div class="inbox-section-title">
              <h6 class="card-title inbox-section-heading mb-0">Pending</h6>
              <span class="badge badge-danger">{{ pendingPagination.totalRecords }}</span>
            </div>
            <auto-table
              [rows]="pendingItems"
              [cols]="pendingCols"
              [enableRowClick]="true"
              [loading]="pendingLoading"
              (onLinkClicked)="goToTask($event)"
              (onRowClicked)="goToTask($event)">
            </auto-table>
            <div class="card-footer">
              <p-paginator #pendingPaginator [rows]="pendingPagination.size" [totalRecords]="pendingPagination.totalRecords" [rowsPerPageOptions]="pageSizes" (onPageChange)="pendingPaginate($event)"></p-paginator>
            </div>
            <br>
            <br>

            <div class="inbox-section-title">
              <h6 class="card-title inbox-section-heading mb-0">Recent Approval Changes</h6>
            </div>
            <auto-table
              [rows]="completedItems"
              [cols]="completedCols"
              [enableRowClick]="true"
              [loading]="completeLoading"
              (onLinkClicked)="goToTask($event)"
              (onRowClicked)="goToTask($event)">
            </auto-table>
            <div class="card-footer">
              <p-paginator #completePaginator [rows]="completePagination.size" [totalRecords]="completePagination.totalRecords" [rowsPerPageOptions]="pageSizes" (onPageChange)="completePaginate($event)"></p-paginator>
            </div>
          </ng-container>
          </div>
        </div>
    </div>
  </div>
</div>
